import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Text } from "react-internationalization";
import { connect } from "react-redux";
class Step1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formerEmpOfSharp: false,
    };
    this.validator = new SimpleReactValidator();
  }

  async componentWillReceiveProps(nextProps) {
    let selectedPlan = nextProps.selectedPlan;
    if (
      selectedPlan === "SDAB20" ||
      selectedPlan === "SDABWD20" ||
      selectedPlan === "SDAP20" ||
      selectedPlan === "SDAPWD20"
    ) {
      await this.setState({ formerEmpOfSharp: true });
    }
  }

  render() {
    const { data, selectedPlan } = this.props;
    // const { formerEmpOfSharp } = this.state;
    console.log(
      !this.validator.check(data.emailAddr, "email") ||
        !data.emailAddr.endsWith(".com") ||
        data.emailAddr === ""
    );

    return (
      <React.Fragment>
        <div class="tab-content tab-contentSharp">
          <div id="step1" class="container tab-pane active">
            <h3 class="tab-heading">
           
              <Text id="step2.Step2" /> – <Text id="step2.subStep" />
            </h3>
            <div class="form-panel">
              <p>
                <strong>
                  A. <Text id="step2.A" />.
                </strong>
              </p>
              {(this.props.year==="2023")&&
              (selectedPlan==="SDABCWD20"||
              selectedPlan==="SDAGC20"||
              selectedPlan==="SDAGCWD20"||
              selectedPlan==="SDAPC20")?(<>
              <div class="form-group">
               
                <label  class="control-label">
                <Text id="step2.Quest23" />.
                </label>
                <div class="row">
                <div  class="col-sm">
                <div
                  >
                    <input
                      type="checkbox"
                      name="ETHNICITY"
                      value="NA"
                      class="customCheckbox"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="NA"?true:false)}                    
                      onChange={
                        this.props.handleStepCheckbox
                      }
                    />
                    <label
                    >
                      <Text id="step2.quesOP1"/>
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"
                      value="PR"
                      name="ETHNICITY"
                      class="customCheckbox"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="PR"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                    />
                    <label
                    >
                      <Text id="step2.quesOP2"/>
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"
                      value="OTH"
                      name="ETHNICITY"
                      class="customCheckbox"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="OTH"?true:false)} 
                      onChange={this.props.handleStepCheckbox}
                    />
                    <label
                     
                    >
                      <Text id="step2.quesOP3"/>
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"
                      value="NR"
                      name="ETHNICITY"
                      class="customCheckbox"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="NR"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                    />
                    <label
                    >
                      <Text id="step2.quesOP4"/>
                    </label>
                  </div>
                  </div>
                  <div  class="col-sm">
                  <div
                  >
                    <input
                      type="checkbox"
                      id="MX"
                      value="MX"
                      name="ETHNICITY"
                      class="customCheckbox"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="MX"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                    />
                    <label
                      class=""
                    >
                      <Text id="step2.quesOP5"/>
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"
                      id="CUB"
                      name="ETHNICITY"
                      value="CUB"
                      class="customCheckbox"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="CUB"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                    />
                    <label
                      class=""
                    >
                      <Text id="step2.quesOP6"/>
                    </label>
                  </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
              
                <label  class="control-label">
                <Text id="step2.ques24"/>.               
                </label>
                <div class="row">
                <div class="col-sm" style={{display:"grid"}}>
                <div
                  >
                    <input
                      type="checkbox"
                      name="RACE"
                      value="300"
                      class="customCheckbox"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="300"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                    />
                    <label
                    >
                      <Text id="step2.American"/> ,
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="431"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="431"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                    >
                    <Text id="step2.Japanese"/>
                    </label>
                  </div>
                  
                  <div
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="451"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="451"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                    >
                       <Text id="step2.Vietnam"/>  
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="201"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="201"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                     
                    >
                     <Text id="step2.Black"/>
                    </label>
                  </div>
                  <div
                   
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="441"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="441"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                    >
                     <Text id="step2.Korean"/>
                    </label>
                  </div>
                  </div>
                  <div class="col-sm" style={{display:"grid"}}>
                  
                  <div
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="499"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="499"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                    >
                    <Text id="step2.OtherAsian"/> 
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="411"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="411"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                      for="language"
                    >
                     <Text id="step2.Chinese"/> 
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="501"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="501"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                      
                    >
                     <Text id="step2.NativeHawaiian"/> 
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="599"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="599"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                      />
                    <label
                    >
                     <Text id="step2.OtherPaci"/> 
                      </label>
                  </div>
                  <div
                   
                   >
                     <input
                       type="checkbox"                    
                       name="RACE"
                       value="421"
                       checked={data.ethnicityRace.some((item)=> item.piValue==="421"?true:false)}
                       onChange={this.props.handleStepCheckbox}
                       class="customCheckbox"
                     />
                     <label
                      
                     >
                      <Text id="step2.Filipino"/> 
                     </label>
                   </div>
                  </div>
                  <div class="col-sm" >
                 
                  <div
                   
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="511"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="511"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                     
                    >
                    <Text id="step2.Samoan"/> 
                    </label>
                  </div>
                  <div
                   
                  >
                    <input
                      type="checkbox"                    
                      name="RACE"
                      value="101"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="101"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                      
                    >
                    <Text id="step2.White"/>
                    </label>
                  </div>
                  <div
                  >
                    <input
                      type="checkbox"
                      name="RACE"
                      value="521"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="521"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                    >
                    <Text id="step2.Guamanian"/>
                    </label>
                  </div>
                  <div                 
                  >
                    <input
                      type="checkbox"
                      name="RACE"
                      value="401"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="401"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                     
                    >
                     <Text id="step2.southAsian"/>
                    </label>
                  </div>
                  <div                 
                  >
                    <input
                      type="checkbox"
                      name="RACE"
                      value="999"
                      checked={data.ethnicityRace.some((item)=> item.piValue==="999"?true:false)}
                      onChange={this.props.handleStepCheckbox}
                      class="customCheckbox"
                    />
                    <label
                     
                    >
                     <Text id="step2.notAns"/>
                    </label>
                  </div>

                 </div>



                </div>
               </div>  
               </>):null} 
              <div class="form-group">
                <div style={{ display: "inline-flex" }}>
                  <label for="language" class="control-label mr-2">
                    <Text id="step2.A1" />.
                  </label>
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                    style={{ marginTop: "1rem" }}
                  >
                    <input
                      type="checkbox"
                      name="language"
                      id="language"
                      class="custom-control-input"
                      value="Spanish"
                      onChange={this.props.handleChange}
                    />
                    <label
                      for="language"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Spanish" />
                    </label>
                  </div>
                </div>
                <fieldset class="radio radio-tab mt-3">
                  <legend>
                    <Text id="step2.A2" />.
                  </legend>
                  <div class="custom-control custom-radio custom-control-inline mt-1">
                    <input
                      type="radio"
                      name="languageValue"
                      id="lfp_braille"
                      class="custom-control-input"
                      value="BRAILLE"
                      checked={data.languageValue === "BRAILLE"}
                      onChange={this.props.handleChange}
                    />
                    <label
                      for="lfp_braille"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Ar1" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline mt-1">
                    <input
                      type="radio"
                      name="languageValue"
                      id="lfp_largeprint"
                      class="custom-control-input"
                      value="LARGE_PRINT"
                      checked={data.languageValue === "LARGE_PRINT"}
                      onChange={this.props.handleChange}
                    />
                    <label
                      for="lfp_largeprint"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Ar2" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline mt-1">
                    <input
                      type="radio"
                      name="languageValue"
                      id="lfp_other"
                      class="custom-control-input"
                      value="OTHER"
                      checked={data.languageValue === "OTHER"}
                      onChange={this.props.handleChange}
                    />
                    <label
                      for="lfp_other"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Ar3" />
                    </label>
                  </div>
                  <div
                    class="custom-control custom-control-inline mt-1"
                    style={{ width: "500px" }}
                  >
                    <input
                      type="text"
                      id="otherlanguageValue"
                      name="languageValue"
                      value={
                        data.languageValue === "BRAILLE" ||
                        data.languageValue === "LARGE_PRINT" ||
                        data.languageValue === "OTHER"
                          ? ""
                          : data.languageValue
                      }
                      disabled={
                        data.languageValue === "" ||
                        data.languageValue === "BRAILLE" ||
                        data.languageValue === "LARGE_PRINT"
                      }
                      onChange={this.props.handleChange}
                      class={"form-control"}
                    />
                  </div>
                </fieldset>
                <br />
                {this.props.year==="2023"?
                <>                
                <Text id="step2.Para1" />
                <a href="tel:1-855-562-8853"> 1-855-562-8853 </a>
                 <Text id="step2.Para23" />
                 </>
                :
                <p class="medicare-note">
                  <Text id="step2.Para1" />
                  <a href="tel:1-855-562-8853"> 1-855-562-8853 </a>
                  <Text id="step2.Para2" />
                </p>}
              </div>
              <div class="form-group">
                <p>
                  <strong>
                    B. <Text id="step2.B" />
                  </strong>
                </p>
                <p class="medicare-note">
                  <Text id="step2.B1" /> &nbsp;
                  <a href="https://sharpmedicareadvantage.com/findadoctor">
                    <Text id="step2.link2" />
                  </a>
                  &nbsp; <Text id="step2.B2" />.
                </p>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <label for="pcpName" class="control-label">
                      <Text id="step2.PCPName" />
                      :*
                    </label>
                    <select
                      name="pcpName"
                      id="pcpName"
                      class={
                        data.pcpName === "" ? "error-input" : "form-control"
                      }
                      onChange={this.props.pcpChange}
                      value={data.pcpName}
                    >
                      {this.props.physicians.map((item, i) => {
                        return (
                          <option
                            class="select-option"
                            value={item.value}
                            key={i}
                          >
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label for="pcpMedicalGroupName" class="control-label">
                      <Text id="step2.ClinicName" />
                      :*
                    </label>
                    <input
                      type="text"
                      id="pcpMedicalGroupName"
                      name="pcpMedicalGroupName"
                      value={data.pcpMedicalGroupName}
                      onChange={this.props.handleChange}
                      style={{ cursor: "not-allowed" }}
                      disabled="true"
                      class={
                        data.pcpMedicalGroupName === ""
                          ? "error-input"
                          : "form-control"
                      }
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <fieldset class="radio radio-tab mt-3">
                      <legend>
                        <Text id="step2.currentpatient" />
                      </legend>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          name="existingp"
                          id="currentPatient_Y"
                          class="custom-control-input"
                          value="Y"
                          checked={data.existingp === "Y"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="currentPatient_Y"
                          class="radio-inline custom-control-label"
                        >
                           <Text id="app.Yes"/>
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          name="existingp"
                          id="currentPatient_no"
                          class="custom-control-input"
                          value="N"
                          checked={data.existingp === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="currentPatient_no"
                          class="radio-inline custom-control-label"
                        >
                          No
                        </label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-md-4">
                    <fieldset class="radio radio-tab mt-3">
                      <legend>
                        <Text id="step2.Dowork" />
                      </legend>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="youwork"
                          id="dDoYouWork_Yes"
                          class="custom-control-input"
                          value="Y"
                          checked={data.youwork === "Y"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="dDoYouWork_Yes"
                          class="radio-inline custom-control-label"
                        >
                           <Text id="app.Yes"/>
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="youwork"
                          id="dDoYouWork_No"
                          class="custom-control-input"
                          value="N"
                          checked={data.youwork === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="dDoYouWork_No"
                          class="radio-inline custom-control-label"
                        >
                          No
                        </label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-md-4">
                    <fieldset class="radio radio-tab mt-3">
                      <legend class="margin-left-0p5">
                        <Text id="step2.spousework" />
                      </legend>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="spousework"
                          id="dDoYourSpouseWork_Yes"
                          class="custom-control-input"
                          value="Y"
                          checked={data.spousework === "Y"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="dDoYourSpouseWork_Yes"
                          class="radio-inline custom-control-label"
                        >
                           <Text id="app.Yes"/>
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline mt-1">
                        <input
                          type="radio"
                          name="spousework"
                          id="dDoYourSpouseWork_No"
                          class="custom-control-input"
                          value="N"
                          checked={data.spousework === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="dDoYourSpouseWork_No"
                          class="radio-inline custom-control-label"
                        >
                          No
                        </label>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div class="row mt-3">
                  {this.props.year !== "2023"?(
                  <div class="col-md-12">
                    <label for="clinicName" class="control-label">
                      <Text id="step2.Email" />...
                      :
                    </label>
                    <input
                      type="text"
                      id="emailAddr"
                      name="emailAddr"
                      value={data.emailAddr}
                      onChange={this.props.handleChange}
                      class="form-control"
                    />
                    <div class="checkbox checkbox-tab mt-1">
                      <div class="custom-control custom-checkbox custom-control-inline ml-0">
                        <input
                          type="checkbox"
                          checked={data.emailAlert === "Y" ? true : false}
                          id="emailAlert"
                          name="emailAlert"
                          defaultChecked
                          class="custom-control-input"
                          onChange={this.props.handleChange}
                        />
                        {this.props.year==="2022"  ?(
                        <label for="emailAlert" class="custom-control-label"> 
                          <Text id="app.news" />. 
                        </label>
                        ):(
                          <label for="emailAlert" class="custom-control-label"> 
                          <Text id="step2.EmailOption"/>. 
                        </label>
                        )}
                      </div>
                    </div>
                  </div>):""}
                  <div class="col-md-12 mt-2">
                    <h4>
                      <Text id="step2.Para3" />
                    </h4>
                    <p>
                      <Text id="step2.Para4" />.
                      <strong>
                        <Text id="step2.Para5" />.
                      </strong>
                    </p>
                    <p>
                      <strong>
                        <Text id="step2.Para6" />.
                      </strong>
                      <Text id="step2.Para6" />.
                    </p>
                  </div>
                </div>
              </div>
              <button
                class="btn btn-saveNext"
                id="next2"
                onClick={this.props.redirect}
                style={{ backgroundColor: "#603167" }}
              >
                <Text id="app.Save_Next" />
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year,
  };
};
export default connect(mapStateToProps)(Step1);